import React from "react";

const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      className="py-2 how-it-works container getstarted">
      <h4
        className="text-center font-heading mb-25 text-white lh-small"
        data-aos="fade-up">
        How It Works{" "}
      </h4>
      <p
        className="text-center font-sm mb-2 text-white lh-small"
        data-aos="fade-up">
        Hire senior software developers/engineers, designers, or outsource
        software engineering teams
      </p>
      <div className="row no-gutters">
        <div className="col-12">
          <h5 className="font-medium mb-1 text-white" data-aos="fade-up">
            As a Company
          </h5>
          <div className="d-flex wrap mb-3 justify-content-between">
            <div
              className="col-md-3 col-sm-5 getstartedbox mb-1 rounded"
              data-aos="fade-up">
              <div className="img font-medium mb-1 one mx-auto">
                <i className="far fa-user"></i>
              </div>
              <div className="text-center">
                <h5 className="font-normal my-50">Account</h5>
                <p className="m-0">First you have to register an account</p>
              </div>
            </div>
            <div
              className="col-md-3 col-sm-5 getstartedbox mb-1 rounded"
              data-aos="fade-up"
              data-aos-delay="100">
              <div className="img font-medium mb-1 two mx-auto">
                <i className="fab fa-wpforms"></i>
              </div>
              <div className="text-center">
                <h5 className="font-normal my-50">Product details</h5>
                <p className="m-0">
                  Send us details on what product you're trying to build
                </p>
              </div>
            </div>
            <div
              className="col-md-3 col-sm-5 getstartedbox mb-1 rounded"
              data-aos="fade-up">
              <div className="img font-medium mb-1 three mx-auto">
                <i className="far fa-handshake"></i>
              </div>
              <div className="text-center">
                <h5 className="font-normal my-50">Rate and Pay</h5>
                <p className="m-0">
                  Once the job is completed, simply rate and confirm payment
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12">
          <h5 className="font-medium mb-1 text-white">As a Developer</h5>
          <div
            className="d-flex wrap justify-content-between mb-3"
            data-aos="fade-up">
            <div className="col-md-3 col-sm-5 getstartedbox mb-1 rounded">
              <div className="img font-medium mb-1 one mx-auto">
                <i className="far fa-user"></i>
              </div>
              <div className="text-center">
                <h5 className="font-normal my-50">Account</h5>
                <p className="m-0">First you have to register an account</p>
              </div>
            </div>
            <div className="col-md-3 col-sm-5 getstartedbox mb-1 rounded">
              <div className="img font-medium mb-1 two mx-auto">
                <i className="fas fa-search"></i>
              </div>
              <div className="text-center">
                <h5 className="font-normal my-50">Quick Jobs</h5>
                <p className="m-0">Find your preferred Jobs</p>
              </div>
            </div>
            <div
              className="col-md-3 col-sm-5 getstartedbox mb-1 rounded"
              data-aos="fade-up">
              <div className="img font-medium mb-1 three mx-auto">
                <i className="fas fa-plug"></i>
              </div>
              <div className="text-center">
                <h5 className="font-normal my-50">Apply</h5>
                <p className="m-0">Finally apply for jobs in your dashboard</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
